import React, { useEffect, useRef } from "react";
import PrizeItem from "./PrizeItem";
import { Link, useLocation } from "react-router-dom";
import * as Middleware from "@middlewares/index";

export const prizesList = [
  {
    id: 1,
    image: "prize-turkey.jpg",
    imageWebp: "prize-turkey.jpg",
    tariffs: [1, 2, 3],
    name: "2 ночи в Турции",
    title: "Приз №1",
    hotels: [
      {
        name: "Six Senses Kocatas Mansions Istanbul",
        description:
          "Двухместное проживание с завтраком на 2 ночи в отеле Six Senses Kocatas Mansions Istanbul",
      },
    ],
  },
  {
    id: 2,
    image: "prize-thailand.png",
    imageWebp: "prize-thailand.png",
    tariffs: [2, 3],
    title: "Приз №2",
    name: "6 ночей в Таиланде",
    hotels: [
      {
        name: "THE BEACH VILLAGE RESORT",
        description: "Двухместное проживание с завтраком на 3 ночи в отеле.",
        postfix: "",
      },
      {
        name: "ORIENTAL BEACH PEARL RESORT",
        description: "Двухместное проживание с завтраком на 3 ночи в отеле.",
        postfix: "",
      },
    ],
  },
  {
    id: 3,
    image: "prize-3.png",
    imageWebp: "prize-3.png",
    tariffs: [2, 3],
    title: "Приз №3",
    name: "4 ночи в Абу-Даби",
    hotels: [
      {
        name: "Khalidiya Palace Rayhaan by Rotana",
        description: "Двухместное проживание с завтраком на 2 ночи в отеле.",
        postfix: "",
      },
      {
        name: "Saadiyat Rotana Resort & Villas",
        description: " Двухместное проживание с завтраком на 2 ночи в отеле.",
        postfix: "",
      },
    ],
  },
  {
    id: 4,
    image: "prize-4.jpeg",
    imageWebp: "prize-4.jpeg",
    tariffs: [3],
    title: "Приз №4",
    name: "Перелет авиакомпанией Emirates",
    hotels: [
      {
        name: "Бесплатный авиабилет от Emirates",
        description: "Перелёт по маршруту Москва - Дубай (DXB) - Москва.",
        postfix: "",
      },
    ],
  },
  {
    id: 5,
    image: "prize-5.jpg",
    imageWebp: "prize-5.jpg",
    tariffs: [3],
    title: "Приз №5",
    name: "4 ночи в Таиланде",
    hotels: [
      {
        name: "Andara Resort & Villas",
        description:
          "Четырехместное проживание с завтраком на 4 ночи (2 ваучера по 2 ночи).",
        postfix: "",
      },
    ],
  },
];

const getTariffText = (tariff: number) => {
  switch (tariff) {
    case 1:
      return "Базовый";
    case 2:
      return "Полный";
    case 3:
      return "Полный плюс";
    default:
      return "Неизвестный тариф";
  }
};

const Prizes = (): JSX.Element => {
  const location = useLocation();
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const anchor = new URLSearchParams(location.search).get("anchor");
    if (anchor === "prizes-anchor" && ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location, ref]);

  return (
    <section
      id="prizes-anchor"
      ref={ref}
      className="bg-grey-f5 py-[54px] md:py-16 lg:py-[100px] 2xl:py-[120px] 3xl:py-[140px]"
    >
      <div className="cont">
        <div className="flex flex-col lg:flex-row gap-8 justify-between">
          <p className="text-36 md:text-48 font-bold">Призовой фонд</p>
          <div className="flex flex-col lg:text-18 gap-3.5 md:w-[456px] xl:w-[544px] 2xl:w-[624px] 3xl:w-[703px] 4xl:w-[744px]">
            <p>
              Зарегистрировавшись на онлайн-выставку, вы становитесь участником
              программы лояльности Profi.Travel Loyalty и получаете баллы за
              активность – просмотр вебинаров и стендов, скачивание каталогов.
              Зарабатывайте как можно больше баллов и участвуйте в розыгрыше
              призов
            </p>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                Middleware.Ui.Modal.open("PrizesRules", {
                  callback: "",
                });
              }}
              className="red-link"
            >
              Подробности розыгрыша призов и правила выдачи дипломов
            </Link>
          </div>
        </div>

        <div className="flex flex-col pt-10 lg:pt-20 gap-5 lg:gap-8">
          {prizesList.map((prize, index) => (
            <React.Fragment key={prize.id}>
              <PrizeItem
                index={index + 1}
                image={prize.image}
                imageWebp={prize.imageWebp}
                tariffs={
                  prize?.tariffs ? prize.tariffs.map(getTariffText) : undefined
                }
                name={prize.name}
                title={prize.title}
                hotels={prize?.hotels}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Prizes;
